import React from 'react'
import styles from './SetUpCompain.module.css'
import homeee from '../Images/HomeLogo.png'
import downArrow from '../Images/downArrow.png'
import upArrow from '../Images/upArrow.png'
import adlogo from '../Images/AdManagerLogo.png'
import map from '../Images/mapLogo.svg'
import mapimg from '../Images/mapImage.png'
import circle from '../Images/circle.png'
import { AiOutlinePlus } from 'react-icons/ai';


const SetUpCompain = () => {
    return (
        <>
            <div className={styles.setUp}>
                <div className={styles.left}>
                    <div className={styles.innerLeft}>
                        <div className={styles.home}>
                            <div className={styles.homtext}>
                                <img src={homeee} className={styles.homeLogo} alt="" />
                                <div className={styles.homText}>Home</div>
                            </div>
                            <img src={downArrow} className={styles.downarr} alt="" />
                        </div>
                        <div className={styles.admanag}>
                            <div className={styles.homtext}>
                                <img src={adlogo} className={styles.homeLogo} alt="" />
                                <div className={styles.adText}>Ad manager</div>
                            </div>
                            <img src={upArrow} className={styles.uparr} alt="" />
                        </div>
                    </div>
                </div>
                <div className={styles.right}>
                    <div className={styles.rightinner}>
                        <div className={styles.compain}>
                            <div className={styles.new}>
                                <div className={styles.heading}>New campaign</div>
                                <div className={styles.objective}>Objective (Beta)</div>
                                <div className={styles.tra}><div className={styles.tarfiic}>Traffic</div><div className={styles.impress}>Impressions</div></div>
                                <div className={styles.campain}>Campaign title*</div>
                                <input type="text" placeholder='example' className={styles.example} />

                            </div>
                            <div className={styles.adTitle}>
                                <div className={styles.object}>Ad title*</div>
                                <input type="text" placeholder='example' className={styles.exampleRight} />
                                <div className={styles.adDescription}>Ad descritpion*</div>
                                <textarea type="text" maxLength={200} placeholder='Autosize height based on content lines' className={styles.desc}></textarea>
                                <div className={styles.limit}>0 / 200</div>

                            </div>
                        </div>
                        <div className={styles.demo}>
                            <div className={styles.comimg}>
                                <div className={styles.leftDemo}>
                                    <div className={styles.mapArea}>
                                        <div className={styles.demoArea}>
                                            <div className={styles.demoText}>Demographics (coming soon)</div>
                                            <div className={styles.slect}>
                                                <input type="checkbox" className={styles.check} />
                                                <div className={styles.select}>select locations +</div>
                                            </div>
                                            <input type="text" placeholder='Continent - Country - City' className={styles.conti} />

                                        </div>
                                    </div>

                                </div>
                                <div className={styles.location}>
                                    <div className={styles.demoleftLocation}>
                                        <img src={map} className={styles.mapLogo} alt="" />
                                        <div className={styles.BlueBox}>
                                            <input type="checkbox" checked className={styles.check} />
                                            <input type="text" className={styles.countr} />
                                            <div className={styles.countText}>Counrty</div>
                                        </div>
                                    </div>
                                    <div className={styles.demorightLoaction}>
                                        <div className={styles.BlueBox}>
                                            <input type="text" className={styles.countr} />
                                            <div className={styles.countText}>Postcode</div>
                                        </div>
                                        <div className={styles.BlueRadius}>
                                            <input type="number" className={styles.radous} />
                                            <div className={styles.countText}>Radius (km)</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.loc}>
                                    <img src={mapimg} alt="" style={{ width: "100%", height: "100%" }} />
                                </div>
                            </div>
                            <div className={styles.landing}>
                                <div className={styles.landingText}>Landingpage URL*</div>
                                <input type="text" placeholder='example' className={styles.exam} />
                                <div className={styles.uploading}>Upload Image I<img src={circle} style={{ marginLeft: "2.5px", marginRight: "2.5px" }} alt="" /> :</div>
                                <div className={styles.upload}>
                                    <div className={styles.imageUpload}><AiOutlinePlus className={styles.plus} /><div className={styles.uploadHeading}>Upload</div></div>
                                    <div className={styles.recom}>Recommanded resolution is 640*640 with file size less than 2MB, keep visual elements centered</div>

                                </div>
                            </div>
                        </div>
                        <div className={styles.lowePart}>
                            <div className={styles.ageArea}>
                                <div className={styles.age}>Age</div>
                                <div className={styles.ageinputs}>
                                    <input type="number" className={styles.numb} />
                                    <input type="text" className={styles.ageText} />
                                </div>
                                <div className={styles.gender}>
                                    <div className={styles.genText}>Gender</div>
                                    <div className={styles.all}>
                                        <div className={styles.allText}>All</div>
                                        <label className={styles.switch}>
                                             <input type="checkbox"  />
                                             <span className={styles.slider}></span>
                                        </label>
                                    </div>
                                </div>
                                <div className={styles.selection}>
                                    <div className={styles.male}>
                                        <input type="checkbox" checked className={styles.check} />
                                        <div className={styles.maleText}>
                                            Male
                                        </div>
                                    </div>
                                    <div className={styles.male} style={{ marginLeft: "10%" }}>
                                        <input type="checkbox" className={styles.check} />
                                        <div className={styles.maleText}>
                                            Female
                                        </div>
                                    </div>
                                    <div className={styles.male} style={{ marginLeft: "10%" }}>
                                        <input type="checkbox" className={styles.check} />
                                        <div className={styles.maleText}>
                                            Other
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className={styles.daily}>
                                <div className={styles.dailyHeading}>Daily budget (mAds)*</div>
                                <div className={styles.budgetArea}>
                                    <input type="text" className={styles.amount} />
                                    <div className={styles.dollar}>$</div>
                                </div>
                                <div className={styles.dateArea}>
                                    <div className={styles.start}>
                                        <div className={styles.dateStart}>Start date*</div>
                                        <input type="text" className={styles.dateInput} />
                                    </div>
                                    <div className={styles.start}>
                                        <div className={styles.dateStart}>End date (optional)</div>
                                        <input type="text" className={styles.dateInput} />
                                    </div>
                                </div>
                                <div className={styles.estReach}>Est reach: (example ~1000 impressions a day)</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SetUpCompain
